import React from 'react';
import { connect } from 'react-redux';
import 'antd/dist/antd.css';
import { Row, Button, Card } from 'antd';
import FileSaver from 'file-saver';
import PropTypes from 'prop-types';

const DownloadPdfButton = ({ contractPdf, contractId }) => {

  const downloadDoc = (b64, label) => {
    const blob = new Blob([Buffer.from(b64, 'base64')], { type: 'application/pdf;charset=utf-8' });
    FileSaver.saveAs(blob, `${label}.pdf`);
  };

  return (
    <Card>
      <Row className="justify-content-center">
        <Button type="default" onClick={() => downloadDoc(contractPdf, `contract-${contractId}`)}>Descargar contrato</Button>
      </Row>
    </Card>
  );
};

DownloadPdfButton.propTypes = {
  contractPdf: PropTypes.string,
  contractId: PropTypes.string,
};

const data = (state) => ({
  contractPdf: state.contract.contractPdf,
});

export default connect(data, null)(DownloadPdfButton);